(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.SalutMenuLogic = api;
})(typeof self !== 'undefined' ? self : this, function () {
  const TZ = 'Europe/Chisinau';
  const WEEKDAYS = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
  const DAY_SETS = { mon_fri: [1, 2, 3, 4, 5], mon_sat: [1, 2, 3, 4, 5, 6], mon_sun: [1, 2, 3, 4, 5, 6, 7] };

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function toMinutes(hhmm) {
    const [h, m] = hhmm.split(':').map(Number);
    return h * 60 + m;
  }

  function normalizeTime(value) {
    const [h, m] = String(value || '').trim().split(':');
    return `${pad(Number(h) || 0)}:${pad(Number(m) || 0)}`;
  }

  function localParts(now) {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ,
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(now);
    const get = (type) => parts.find((p) => p.type === type).value;
    return {
      weekday: WEEKDAYS[get('weekday')],
      date: `${get('year')}-${get('month')}-${get('day')}`,
      minutes: Number(get('hour')) * 60 + Number(get('minute'))
    };
  }

  function isWithinSchedule(schedule, now) {
    let local;
    try {
      local = localParts(now);
    } catch (error) {
      return true;
    }
    if (!schedule.days.includes(local.weekday)) return false;
    if (schedule.holidays.includes(local.date)) return false;
    return local.minutes >= toMinutes(schedule.start) && local.minutes < toMinutes(schedule.end);
  }

  function parseSchedule(dataset) {
    return {
      days: [...(DAY_SETS[dataset.opsDays] || DAY_SETS.mon_fri)],
      start: normalizeTime(dataset.opsStart),
      end: normalizeTime(dataset.opsEnd),
      holidays: String(dataset.opsHolidays || '')
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => /^\d{4}-\d{2}-\d{2}$/.test(line))
    };
  }

  function formatCount(n, lang) {
    const digits = String(Math.max(0, Math.trunc(Number(n) || 0)));
    const separator = lang === 'ru' ? '\u00A0' : '.';
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  function fold(text) {
    return String(text).normalize('NFD').replace(/[\u0300-\u036F]/g, '').toLowerCase();
  }

  function groupBrands(brands, lang) {
    const sorted = [...brands].sort((a, b) => {
      const aFold = fold(a.title);
      const bFold = fold(b.title);
      return aFold.localeCompare(bFold, lang) || a.title.localeCompare(b.title, lang);
    });
    const groups = new Map();
    sorted.forEach((brand) => {
      const first = fold(brand.title).charAt(0).toUpperCase();
      const letter = /[A-Z]/.test(first) ? first : '#';
      if (!groups.has(letter)) groups.set(letter, []);
      groups.get(letter).push(brand);
    });
    return [...groups.keys()]
      .sort((a, b) => (a === '#' ? -1 : b === '#' ? 1 : a.localeCompare(b)))
      .map((letter) => ({ letter, items: groups.get(letter) }));
  }

  function filterBrands(brands, query) {
    const needle = fold(query).trim();
    if (!needle) return brands;
    return brands.filter((brand) => fold(brand.title).includes(needle));
  }

  return { isWithinSchedule, parseSchedule, formatCount, groupBrands, filterBrands };
});

